export default __webpack_public_path__ + "static/media/home.c0d01b44.png";